module.exports = __webpack_public_path__ + "img/FIA_Logo.0e560278.png";